import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Alert, Collapse, IconButton, Paper, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BoxContainer } from '../layouts/Theme';
import { useI18N } from '../context/I18NContext';
import { useFlow } from '../context/FlowContext';
import { useSettings } from '../context/SettingsContext';
import CartSimple from '../partials/checkout/CartSimple';
import BottomBar from '../partials/BottomBar';
import useWidgetStore from '../store/useWidgetStore';
import { useNavigate } from 'react-router-dom';
import { isMobile } from '../../../helpers/browser';
import { useEffect, useState } from 'react';
export default function ShoppingCart(props) {
    var _a, _b, _c, _d;
    const { t, ts } = useI18N();
    const theme = useTheme();
    const flow = useFlow();
    const navigate = useNavigate();
    const { orientation, widgetMode } = useSettings();
    const { cart, booking } = useWidgetStore();
    const [removedProduct, setRemovedProduct] = useState(false);
    const [removedProductName, setRemovedProductName] = useState("Product");
    const toNext = () => {
        if (flow.onNext) {
            flow.onNext();
        }
    };
    const toShop = () => {
        if (orientation === "horizontal") {
            navigate("/oa_widget_shop");
        }
        else {
            if (flow.onPrevious) {
                flow.onPrevious();
            }
        }
    };
    const selectCallback = (product) => {
        setRemovedProduct(true);
        setRemovedProductName(product.name);
    };
    useEffect(() => {
        if (removedProduct) {
            setTimeout(() => {
                if (removedProduct) {
                    setRemovedProduct(false);
                }
            }, 10000);
        }
    }, [removedProduct]);
    return (_jsxs(BoxContainer, { sx: {
            maxWidth: orientation === "horizontal" || widgetMode === "standalone" ? '100%' : "468px", // 500px - 2x 16px padding
            paddingTop: 2
        }, children: [_jsx(Collapse, { in: removedProduct, children: _jsx(Paper, { elevation: 4, sx: Object.assign({ padding: 2, margin: 1, marginY: 4, position: 'sticky', top: isMobile
                            ? '32px'
                            : widgetMode === 'standalone' ? '16px' : '42px', zIndex: 1, 
                        // position: 'fixed',
                        // top: "90px",
                        marginX: isMobile ? 2 : 1 }, (isMobile && {
                        width: "calc(100% - 64px)"
                    })
                    // width: isMobile
                    //     ? "calc(100% - 64px)"
                    //     : widgetMode === 'standalone' ? "calc(100% - 110px)" : "calc(100% - 66px)"
                    ), children: _jsx(Alert, { severity: "success", sx: {
                            marginBottom: 2
                        }, action: _jsx(IconButton, { "aria-label": "close", color: "inherit", size: "small", onClick: () => {
                                setRemovedProduct(false);
                            }, children: _jsx(CloseIcon, { fontSize: "inherit" }) }), children: ts("%name% is verwijderd uit je winkelwagen", { name: removedProductName }) }) }) }), ((cart.lines && ((_a = cart.lines) === null || _a === void 0 ? void 0 : _a.length) > 0) || (booking.appointments && ((_b = booking.appointments) === null || _b === void 0 ? void 0 : _b.length) > 0)) && (_jsxs(_Fragment, { children: [_jsx(CartSimple, { selectCallback: selectCallback }), orientation === "horizontal" && (_jsxs(_Fragment, { children: [_jsx(Button, { fullWidth: isMobile, sx: { margin: isMobile ? "0 0 16px 0" : "0 16px 0 0" }, variant: "outlined", onClick: toShop, children: t("Verder winkelen") }), _jsx(Button, { fullWidth: isMobile, variant: "contained", onClick: toNext, children: t("Verder met afrekenen") })] })), orientation === "vertical" && (_jsx(BottomBar, { children: _jsx(Button, { onClick: toNext, fullWidth: true, sx: {
                                my: '16px'
                            }, variant: "contained", children: t("Volgende stap") }) }))] })), (!cart.lines || ((_c = cart.lines) === null || _c === void 0 ? void 0 : _c.length) === 0) && (!booking.appointments || ((_d = booking.appointments) === null || _d === void 0 ? void 0 : _d.length) === 0) && (_jsxs(_Fragment, { children: [_jsx(Typography, { sx: { marginY: 2, color: theme.palette.text.primary, fontStyle: 'italic' }, variant: "subtitle2", children: t('Je hebt geen producten in je winkelwagen') }), _jsx(Button, { variant: "contained", onClick: toShop, children: t("Naar de webshop") })] }))] }));
}
